<template>
<app-link to="/my-center/rechange" class="rechange-banner-advert" v-if="visible || showClose === false">
  <div class="bgc" />
  <div class="part-group">
    <div class="part p1" />
    <div class="part p2" />
    <div class="part p3" />
  </div>
  <svg-icon class="close-btn" icon="close" @click.prevent.stop="handeClose" size="24" v-if="showClose" />
</app-link>
</template>

<script>
import Cookies from 'js-cookie'
const COOKIE_KEY = 'rechange_banner_ad_hidden'
export default {
  name: 'RechangeBannerAdvert',
  props: {
    showClose: Boolean,
  },
  data: () => ({
    visible: (Cookies.get(COOKIE_KEY) - 0) !== 1,
  }),
  methods: {
    handeClose() {
      Cookies.set(COOKIE_KEY, 1, { expires: 1 })
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rechange-banner-advert {
  height: 145px;
  overflow: hidden;
  position: relative;
  text-align: center;
  font-size: 0;
  display: block;

  .bgc {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 120px;
    overflow: hidden;
    border-radius: 4px;
    background-image: linear-gradient(134deg, #FED0CC 0%, #FFF0F0 55%, #FFFFFF 100%);
  }

  .part-group {
    position: relative;
    display: inline-flex;
    justify-content: space-between;
    min-width: 949px;
    max-width: 1068px;
    width: 100%;
    height: 100%;
  }

  .part {
    height: 100%;
    background: no-repeat left top / contain;

    &.p1 {
      background-image: url(~@/images/recharge_part1.png);
      width: 283px;
    }

    &.p2 {
      background-image: url(~@/images/recharge_part2.png);
      width: 386px;
    }

    &.p3 {
      background-image: url(~@/images/recharge_part3.png);
      width: 279px;
    }
  }

  .close-btn {
    position: absolute;
    z-index: 1;
    right: 0;
    top: 0;
    color: #A7A7A8;
  }
}
</style>
